import { CdkDrag } from '@angular/cdk/drag-drop';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { reformatDate } from '@approot/utilities';
import { chartOptions } from '../back-to-back-trades.funcs';
import { GetWhiteLabelRfqItem } from '../back-to-back-trades.types';

const WIN_POSITION_MIN_X = 8;
const WIN_POSITION_MIN_Y = 36;
const WIN_POSITION_RIGHT_MIN = 100;

@Component({
  selector: 'app-back-to-back-trades-chart',
  templateUrl: './back-to-back-trades-chart.component.html',
  styleUrls: ['./back-to-back-trades-chart.component.scss']
})
export class BackToBackChartComponent implements OnInit, OnChanges {
  @Input() public rowData: GetWhiteLabelRfqItem[] = [];
  @Input() public startDate: string;
  @Input() public endDate: string;
  @Output() public chartClose = new EventEmitter<void>();
  @ViewChild(CdkDrag) public dragEl: CdkDrag;

  public dragging = false;
  public windowTop = 70;
  public windowLeft = 500;
  public isVisible = true;
  public chartOptions: any;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {}

  public ngOnInit(): void {
    this.initializeGraph();
  }

  public ngOnChanges(_changes: SimpleChanges): void {
    this.initializeGraph();
  }

  public initializeGraph(): void {
    const filteredPnlData = this.rowData.filter(row => {
      const pnl = row.pnlInReportingCurrency;
      return pnl !== 0 && pnl !== null && pnl !== undefined;
    });

    if (filteredPnlData.length === 0) {
      this.chartOptions = {};
      return;
    }

    const ascendingRowData = filteredPnlData.sort(
      (a, b) =>
        new Date(a.timestamp_str).getTime() -
        new Date(b.timestamp_str).getTime()
    );

    let cumulativePnl = 0;
    const rowDataWithCumulativePnl = ascendingRowData.map(row => {
      const pnl =
        row.pnlInReportingCurrency !== undefined
          ? row.pnlInReportingCurrency
          : 0;
      cumulativePnl += pnl;

      return {
        ...row,
        timestamp: new Date(row.timestamp_str),
        cumulativePNL: cumulativePnl,
        pnlInReportingCurrency: pnl,
        rfqStartTimestamp: row.timestamp_str
      };
    });

    const formattedStartTime = reformatDate(this.startDate, 'D MMM YYYY');
    const titleText = formattedStartTime
      ? `Margin since ${formattedStartTime}`
      : 'Margin';

    this.chartOptions = chartOptions(titleText, rowDataWithCumulativePnl);
  }

  public onClose(): void {
    this.chartClose.emit();
    this.isVisible = false;
  }

  public dragStart(): void {
    this.dragging = true;
  }

  public async dragEnd(): Promise<void> {
    this.dragging = false;
    const el = this.elementRef.nativeElement.querySelector(
      '.back-to-back-chart-container'
    );
    const rect = el.getBoundingClientRect();

    let { x, y } = this.dragEl.getFreeDragPosition();

    if (rect.x < WIN_POSITION_MIN_X) {
      x += WIN_POSITION_MIN_X - rect.x;
    }
    if (rect.y < WIN_POSITION_MIN_Y) {
      y += WIN_POSITION_MIN_Y - rect.y;
    }
    if (rect.x > window.innerWidth - WIN_POSITION_RIGHT_MIN) {
      x -= rect.x - (window.innerWidth - WIN_POSITION_RIGHT_MIN);
    }
    this.dragEl.setFreeDragPosition({ x, y });
  }

  public updateZIndex(): void {
    this.renderer.setStyle(
      this.elementRef.nativeElement.querySelector(
        '.back-to-back-chart-container'
      ),
      'z-index',
      '1000'
    );
  }
}
